
(function () {
    angular.module('customeDirectivesModule')
        .directive('npBreadcrumbs', npBreadcrumbs);

    function npBreadcrumbs() {
        var directive = {
            restrict: 'EA',
            replace: true,
            templateUrl: '/app/shared/breadcrumbs/breadcrumbsTemplate.html',
            scope: {
            },
            link: linkFunction,
            controller: ['$rootScope', '$scope', '$location', '$state', '$timeout', '$http', 'broadcastService', 'localStorageService', 'tabStateService', 'browserService', controller],
            controllerAs: 'vm'
        };

        return directive;

        function linkFunction(scope, el, attr, ctrl) {

        };

        function controller($rootScope, $scope, $location, $state, $timeout, $http, broadcastService, localStorageService, tabStateService, browserService) {
            var vm = this;
            vm.scope = $scope;
            vm.translation = {
                home: globalResources.Home,
                searchResult: globalResources.SearchResult,
                viewNews: globalResources.News
            };

            vm.url = $location.path();
            vm.breadcrumbs = [];
            vm.otherBreadcrumbs = [];
            vm.fullBreadcrumbsMobile = [];
            vm.navigateToFolder = navigateToFolder;
            vm.isSearchResultView = false;
            vm.isNewsView = false;
            vm.setMasterTab = setMasterTab;
            vm.goToNewsList = goToNewsList;
            vm.showAllBreadcrumbs = showAllBreadcrumbs;
            vm.getFolderIconMobile = getFolderIconMobile;
            vm.BROWSER_TYPE = BrowserType;
            vm.browserType = browserService.detectBrowserWindow();
            vm.showDropdown = false;
            vm.goToFolder = goToFolder;
           

            initialize();

            function initialize() {
                vm.isDocumentAction = false;
                vm.isFolderAction = false;
                vm.hasSubFolders = false;
                getBreadcrumbs();
            };

            function setMasterTab() {
                tabStateService.setState(tabStateType.homeTabState, homeTabs.startPage);
            }

            function getBreadcrumbs() {
                var element = vm.url.split('/');
                if (element != undefined && element.length > 0) {
                    var requestParams = {
                        itemId: element[2],
                        itemType: element[1]
                    };

                    var validCondition = (requestParams.itemType == handbookActions.DocumentAction
                        || requestParams.itemType == handbookActions.FolderAction)
                        && !isNaN(requestParams.itemId);

                    vm.isDocumentAction = requestParams.itemType == handbookActions.DocumentAction;
                    vm.isFolderAction = requestParams.itemType == handbookActions.FolderAction;

                    if (validCondition) {
                        $http.get(handbookRequests.GetParentFoldersRequest, { params: requestParams })
                             .then(function (response, status, headers, config) {
                                 if (vm.isFolderAction) {
                                     $http.get(handbookRequests.GetSubfoldersRequest, { params: { 'folderId': element[2] } })
                                          .success(function (data, status, headers, config) {
                                              vm.hasSubFolders = (data != null && data.length > 0);
                                              if (vm.hasSubFolders) {
                                                  buildSubFoldersBreadcrumbs(data);
                                              }
                                              buildBreadcrumbs(response.data);
                                          });
                                 } else {
                                     buildBreadcrumbs(response.data);
                                 }
                             });
                    } else {
                        buildOthersBreadcrumbs(requestParams);
                    }

                    vm.isSearchResultView = requestParams.itemType.contains(handbookActions.SearchResultAction);
                    vm.isNewsView = (requestParams.itemType === handbookActions.NewsListAction)
                                    || (requestParams.itemType === handbookActions.StartpageNews)
                                    || (requestParams.itemType === handbookActions.NewsCategoryAction);
                }
            };

            function buildSubFoldersBreadcrumbs(data) {
                for (var i = 0; i < data.length; i++) {
                    data[i].icon = getFolderIcon(data[i].type);
                }
                if (!(typeof data === 'string')) {
                    vm.subFolders = data;
                }
            };

            function navigateToFolder(sub) {
                $state.go(handbookActions.FolderAction, { folderId: sub.id });
            };

            function goToNewsList() {
                if ($state.$current.name == handbookActions.StartpageNews) {
                    $state.go(handbookActions.NewsListAction, { pageIndex: user.currentNewsPage });
                } else {
                    $state.go(handbookActions.NewsListAction);
                }
            }

            function buildOthersBreadcrumbs(requestParams) {
                switch (requestParams.itemType) {
                    case handbookActions.HandbookAdminAction:
                        addAdminBreadcrums();
                        break;
                    case handbookActions.HandbookManagementAction:
                        addAdminBreadcrums();
                        addHandbookBreadcrums();
                        break;
                    case handbookActions.DocumentTemplateAction:
                        addAdminBreadcrums();
                        addHandbookBreadcrums();
                        vm.otherBreadcrumbs.push({
                            id: handbookActions.DocumentTemplateAction,
                            name: resources.L.Action.documentTypes,
                            icon: 'fa fa-file-image-o'
                        });
                        break;
                    case handbookActions.DocumentFieldsAction:
                        addAdminBreadcrums();
                        addHandbookBreadcrums();
                        vm.otherBreadcrumbs.push({
                            id: handbookActions.DocumentFieldsAction,
                            name: resources.L.Action.fieldList,
                            icon: 'fa fa-list-ul'
                        });
                        break;
                    case handbookActions.RolesAction:
                        addAdminBreadcrums();
                        vm.otherBreadcrumbs.push({
                            id: handbookActions.RolesAction,
                            name: resources.L.Action.roles,
                            icon: 'fs22 icon-ehand_tilgang2 vtca-tb'
                        });
                        break;
                    case handbookActions.StaffManagementAction:
                        addAdminBreadcrums();
                        vm.otherBreadcrumbs.push({
                            id: handbookActions.StaffManagementAction,
                            name: resources.L.Action.staff,
                            icon: 'fs20 typcn typcn-user-outline'
                        });
                        break;
                    case handbookActions.DepartmentsManagementAction:
                        addAdminBreadcrums();
                        vm.otherBreadcrumbs.push({
                            id: handbookActions.DepartmentsManagementAction,
                            name: resources.L.Action.departments,
                            icon: 'fs20 typcn typcn-group-outline'
                        });

                        broadcastService(broadcastType.sidebarNav, { id: sidebarTypes.DEPARTMENT });
                        showSidebar();
                        break;
                    default:
                        break;
                }

                if (vm.otherBreadcrumbs != null && vm.otherBreadcrumbs.length > 0 && (requestParams.itemType != handbookActions.DepartmentsManagementAction)) {
                    hideSidebar();
                } else {
                    showSidebar();
                }
            }

            function showSidebar() {
                if (angular.element('body.sidebar-hidden').length || angular.element('body.sidebar-rtl').length) {
                    angular.element('body').addClass('sidebar-ltr').removeClass('sidebar-hidden sidebar-rtl');
                    angular.element('#toggle_sidemenu_l').show();
                }
            };

            function hideSidebar() {
                angular.element('body').addClass('sidebar-hidden').removeClass('sidebar-ltr sidebar-rtl');
                angular.element('#toggle_sidemenu_l').hide();
                angular.element('.navbar-brand').attr('style', 'margin-left: 40px;');
            }

            function addAdminBreadcrums() {
                vm.otherBreadcrumbs.push({
                    id: handbookActions.HandbookAdminAction,
                    name: resources.L.Action.admin,
                    icon: 'fs20 typcn typcn-microphone-outline'
                });
            }

            function addHandbookBreadcrums() {
                vm.otherBreadcrumbs.push({
                    id: handbookActions.HandbookManagementAction,
                    name: resources.L.Action.handbook,
                    icon: 'fa fa-folder-o'
                });
            }

            function buildBreadcrumbs(data) {
                var totalItem = data.length;

                //move root to result array
                for (var i = 0; i < data.length; i++) {
                    if (data[i].parentFolderId == null) {
                        data[i].icon = getFolderIcon(data[i].type);
                        data[i].iconMobile = getFolderIconMobile(data[i].levelType);
                        vm.breadcrumbs.push(data[i]);
                        data.splice(i, 1);
                        break;
                    }
                }

                //fill in the rest
                var currentItem = 0;
                while (vm.breadcrumbs.length != totalItem && currentItem <= vm.breadcrumbs.length) {
                    for (var i = 0; i < data.length; i++) {
                        if (vm.breadcrumbs[currentItem].id == data[i].parentFolderId) {
                            data[i].icon = getFolderIcon(data[i].type);
                            data[i].iconMobile = getFolderIconMobile(data[i].levelType);
                            vm.breadcrumbs.push(data[i]);
                            data.splice(i, 1);
                            break;
                        }
                    }
                    currentItem++;
                }
                vm.fullBreadcrumbs = angular.copy(vm.breadcrumbs);
                vm.fullBreadcrumbsMobile = angular.copy(vm.breadcrumbs).reverse();
                breadcrumbsCompact();
            };

            function breadcrumbsCompact() {
                vm.isBreadcrumbsCompact = false;
                vm.mobileView = false;
                $timeout(function () {
                    var divBreadcrumb = angular.element('.np-breadcrumbs');
                    var lineHeight = divBreadcrumb.height();
                    var documentWidth = $(document).width();
                    if (documentWidth > 667) {
                        if (lineHeight > 28) {
                            var arrTemp = [];
                            if (vm.breadcrumbs && vm.breadcrumbs.length > 2) {
                                vm.isBreadcrumbsCompact = true;
                                arrTemp.push(vm.breadcrumbs[vm.breadcrumbs.length - 2]);
                                arrTemp.push(vm.breadcrumbs[vm.breadcrumbs.length - 1]);
                                vm.breadcrumbs = arrTemp;
                                refreshScrollContentView();
                            }
                        }
                    } else {
                        if (lineHeight > 28) {
                            var arrTemp = [];
                            if (vm.breadcrumbs && vm.breadcrumbs.length > 1) {
                                vm.mobileView = true;
                                vm.isBreadcrumbsCompact = true;
                                arrTemp.push(vm.breadcrumbs[vm.breadcrumbs.length - 1]);
                                vm.breadcrumbs = arrTemp;
                                refreshScrollContentView();
                            }
                        }
                    }

                }, 100);
            };

            function showAllBreadcrumbs() {
                vm.isBreadcrumbsCompact = false;
                vm.mobileView = false;
                vm.breadcrumbs = angular.copy(vm.fullBreadcrumbs);
                refreshScrollContentView();
            };

            function updateBreadcrumbs() {
                vm.breadcrumbs = [];
                vm.otherBreadcrumbs = [];
                vm.url = $location.path();
                getBreadcrumbs();
            };

            $(window).on('resize', function () {
                vm.breadcrumbs = angular.copy(vm.fullBreadcrumbs);
                $timeout(function () {
                    breadcrumbsCompact();
                }, 0, false);
            });

            function refreshScrollContentView() {
                if (vm.url.contains('document')) {
                    adjustDocumentContentPosition();
                } else if (vm.url.contains('folder')) {
                    adjustChapterContentPosition();
                }
            };

            function adjustChapterContentPosition() {
                var tabState = tabStateService.getState(tabStateType.chapterTabState);
                $timeout(function () {
                    tabStateService.adjustContentPosition(tabState, tabStateType.chapterTabState);
                }, 0, false);
            };

            function adjustDocumentContentPosition() {
                var tabState = tabStateService.getState(tabStateType.documentTabState);
                $timeout(function () {
                    tabStateService.adjustContentPosition(tabState, tabStateType.documentTabState);
                }, 0, false);
            }

            function getFolderIcon(folderType) {
                if (folderType != null) {
                    switch (folderType.toString()) {
                        case E.nodeTypes.Folder:
                            return paths.FolderIcon;
                        case E.nodeTypes.TopFolder:
                            return paths.TopFolderIcon;
                        case E.nodeTypes.DepartmentFolder:
                            return paths.DepartmentFolderIcon;
                        case E.nodeTypes.RegionalFolder:
                            return paths.RegionalFolderIcon;
                        default:
                            return paths.FolderIcon;
                    }
                } else {
                    return paths.FolderIcon;
                }
            }

            function getFolderIconMobile(folderType) {
                switch (folderType.toString()) {
                    case E.folderTypes.Folder:
                        return 'folder-blue-icon';
                    case E.folderTypes.TopFolder:
                        return 'folder-orange-icon';
                    case E.folderTypes.DepartmentFolder:
                        return 'folder-green-icon';
                    case E.folderTypes.RegionalFolder:
                        return 'folder-regional-icon';
                    default:
                        return 'folder-blue-icon';
                }
            }

            function goToFolder(folder) {
                window.open(`/folder/${folder.id}`, '_self');
            }
        }
    };
})();